const focusableSelectors = [
  'a[href]',
  'area[href]',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  'iframe',
  'object',
  'embed',
  // '[role="dialog"]', // We may need to turn this back on in the future for a11y reasons.
  '[role="button"]',
  '[role="checkbox"]',
  '[role="switch"]',
  '*[tabindex]:not([tabindex="-1"])',
  '*[contenteditable]',
]

export default focusableSelectors.join(',')
